/**
 * Client helpers for free-form chat artifacts (table / doc).
 * Mirror of server boardChatArtifacts shapes — keep in sync with canvas-ai-jobs.md
 */

export function tableToCsv(table) {
  if (!table?.columns?.length) return '';
  const escape = cell => {
    const s = String(cell ?? '');
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const lines = [
    table.columns.map(escape).join(','),
    ...(table.rows || []).map(row => (row || []).map(escape).join(',')),
  ];
  return `\uFEFF${lines.join('\n')}`;
}

export function artifactToCanvasText(artifact) {
  if (!artifact) return '';
  const title = String(artifact.title || '').trim();
  if (artifact.kind === 'table' && artifact.table) {
    const { columns, rows } = artifact.table;
    const header = `| ${columns.join(' | ')} |`;
    const sep = `| ${columns.map(() => '---').join(' | ')} |`;
    const body = (rows || []).map(r => `| ${(r || []).join(' | ')} |`).join('\n');
    const tableBlock = `${header}\n${sep}\n${body}`;
    return title ? `${title}\n\n${tableBlock}` : tableBlock;
  }
  if (artifact.kind === 'doc' && artifact.doc?.body) {
    return title ? `${title}\n\n${artifact.doc.body}` : artifact.doc.body;
  }
  return title;
}

export function downloadArtifactCsv(artifact) {
  if (artifact?.kind !== 'table' || !artifact.table) return false;
  const csv = tableToCsv(artifact.table);
  if (!csv) return false;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const safeName = String(artifact.title || 'table')
    .replace(/[^\w\uac00-\ud7a3\- ]+/g, '')
    .trim()
    .slice(0, 80) || 'table';
  a.href = url;
  a.download = `${safeName}.csv`;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}

export function downloadArtifactDoc(artifact) {
  if (artifact?.kind !== 'doc' || !artifact.doc?.body) return false;
  const body = artifactToCanvasText(artifact);
  const blob = new Blob([body], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const safeName = String(artifact.title || 'document')
    .replace(/[^\w\uac00-\ud7a3\- ]+/g, '')
    .trim()
    .slice(0, 80) || 'document';
  a.href = url;
  a.download = `${safeName}.md`;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}
